import { WorkflowType } from "@/pages/query/types";

export const getWorkflowNavigationPrefix = (workflowType: WorkflowType): string => {
  return workflowType === WorkflowType.TABLEAU ? "/query/tableau-jobs" : "/query/snowflake-jobs";
};

export const getWorkflowTerminology = (workflowType: WorkflowType, term: string): string => {
  const tableauTerminologyMap: Record<string, string> = {
    "Jobs Cost": "Dashboard Cost",
    "Jobs List": "Dashboard List",
    Project: "Instance",
    Projects: "Instances",
    App: "Site",
    Apps: "Sites",
  };

  if (workflowType === WorkflowType.TABLEAU && tableauTerminologyMap[term]) {
    return tableauTerminologyMap[term];
  }

  return term;
};

export const getWorkflowIdLabel = (workflowType: WorkflowType): string => {
  return workflowType === WorkflowType.TABLEAU ? "Dashboard Name" : "Workload ID";
};
